import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { TitreTexteInfo } from '@components/titre-texte-info/models';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { HandleHtmlLinksDirective } from '@shared/directives';

@Component({
  selector: 'app-titre-texte-info',
  imports: [SvgComponent, TitleComponent, HandleHtmlLinksDirective],
  templateUrl: './titre-texte-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitreTexteInfoComponent extends AbstractDynamicComponent<TitreTexteInfo> {}
